import Vue from "vue"
import App from "@/App.vue"
import i18n from "@/config/lang.js"
import "babel-polyfill"
import router from "@/config/router"
import locale from "element-ui/lib/locale/lang/en"
import Element from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "@/assets/css/bootstrap.css"
import "@/assets/css/public.css"
import "@/assets/css/style.css"
import { store } from "@/store/store.js"
import { global } from "@/config/global"

Vue.use(Element, { locale })

Vue.config.productionTip = false
Vue.prototype.$global = global

sessionStorage.setItem("Accept-Language", i18n.locale)
store.dispatch("setLanguage", i18n.locale)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
